<template>
	<div :class="{ 'isLoading': isLoading }">
		<v-autocomplete
			:hide-details="hideDetails"
			:clearable="clear"
			class="base-select reduce-div"
			v-bind="$attrs"
			:label="label"
			v-if="!isLoading"
			:items="items"
			:value="value"
			@input="sendValue"
		></v-autocomplete>
	</div>
</template>
<script>

	function sendValue(val) {
		this.$emit('input', val);
	}

	export default {
		name: 'header-select',
		inheritAttrs: false,
		methods: {
			sendValue,
		},
		props: {
			hideDetails: {
				type: Boolean,
				default: true,
			},
			isLoading: {
				type: Boolean,
				default: false,
			},
			items: {
				default: () => [],
				type: Array,
			},
			label: String,
			value: null,
			clear: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/base-select.vue